import React from 'react';
import { Image, Message } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import logo from "../../images/logo/logo-full-black.png";
import LoadingComponent from "../common/LoadingComponent";
import ModalHeader from './../drive/ModalHeader'
import styles from './styles.css';

class ActiveUserLogin extends React.Component {
    constructor(props) {
        super(props);

        // reset login status
        // dispatch.login.logout();

        this.onSubmit = this.onSubmit.bind(this);
        this.gotToForgotPassword = this.gotToForgotPassword.bind(this);
    }

    onSubmit(formData) {
        let payload = {
            formData,
        }

        dispatch.login.loginAsync(payload);
    }

    componentWillMount() {
        let userid = this.props.match.params.userid;
        dispatch.register.activateUser(userid);
    }

    gotToForgotPassword(e) {
        e.preventDefault();
        const { history } = this.props;
        history.push('/forgotpassword');
    }


    render() {
        const { loggingIn, activatingIn, loginError, registrationError } = this.props;

        let activationStatus = null;
        let loginForm = null;
        if (registrationError) {
            activationStatus =
                (<Message
                    icon='inbox'
                    error
                    header='Error!'
                    content='Invalid Activation Code.'
                    style={{ margin: '0 auto' }}
                />)
        } else {
            if (loginError === null) {
                activationStatus =
                    (<Message
                        icon='inbox'
                        success
                        header='Congratulations!'
                        content='Your email address is verified.'
                        style={{ margin: '0 auto' }}
                    />);
            }

            loginForm = (
                <Form noValidate
                    className="loginform"
                    error
                    ref={ref => this.form = ref}
                    onValidSubmit={this.onSubmit}
                >

                    <Image src={logo} size='medium' centered />

                    {loginError != null && (loginError.message === "Invalid login"
                        || loginError.message === "User is Deactivated.") ?
                        <Message
                            error
                            content={`Invalid email/password!`}
                        /> : ''}

                    <Form.Input
                        name="email"
                        label="Email"
                        placeholder="Email"
                        icon="envelope"
                        iconPosition="left"
                        required
                        validations="isEmail"
                        errorLabel={errorLabel}
                        validationErrors={{
                            isEmail: 'This is not a valid email',
                            isDefaultRequiredValue: 'Email is required',
                        }}
                        autoFocus
                    />
                    <Form.Input
                        icon='key'
                        iconPosition='left'
                        label="Password"
                        type="password"
                        required
                        placeholder="Password"
                        name="password"
                        errorLabel={errorLabel}
                        validationErrors={{
                            isDefaultRequiredValue: 'Password is required',
                        }}
                    />
                    <div className="ui grid pad_lr_0">
                        <div className="two column row">
                            <div className="left floated column">
                                <a className="supportLink item middle aligned cursor-pointer" onClick={this.gotToForgotPassword} >Forgot Password?</a>
                            </div>
                            <div className="right floated column actionInFormcy border-none">
                                <Button floated='right' className="button-submit" type="submit">Login</Button>
                            </div>
                        </div>
                    </div>
                </Form>
            )
        }

        const errorLabel = <div className="customErrorLabel" />;
        return (
            <div className="inner">
                <LoadingComponent active={activatingIn || loggingIn} message="Logging in" />
                <ModalHeader
                    header={<img src={`${logo}`} alt='' />}
                    subHeader="Welcome!" />

                {activationStatus}
                {loginForm}

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loggingIn: state.loading.effects.login.loginAsync && state.loading.models.login,
        activatingIn: state.loading.effects.register.activateUser,
        loginError: state.login.loginError,
        registrationError: state.register.registrationError
    };
}

const connectedRegisterPage = connect(mapStateToProps)(ActiveUserLogin);

export { connectedRegisterPage as ActiveUserLogin };